import moment from 'moment';
import { getCoverageTypeName, getStatusAuthorizationName} from '@/utils/v2/authorization-v2.utils.js';
import { camelizeKeys, camelize } from 'humps';

export default {
  authorizationDetailForm: state => state.authorizationDetailForm,
  authorizationWithoutClaim: state => {
    if (state.authorizationWithoutClaim && state.authorizationWithoutClaim.length > 0) {
      return state.authorizationWithoutClaim.map(authorization => {
        return {
          id: authorization.id,
          createdAt: moment(authorization.createdAt).format('DD/MM/YYYY'),
          sponsorName: authorization.sponsorName,
          sponsorSlug: authorization.sponsorSlug,
          beneficiaryName: authorization.beneficiaryName,
          beneficiaryId: authorization.beneficiaryId,
          beneficiaryMemberCode: authorization.beneficiaryMemberCode,
          identityDocumentType: authorization.identityDocumentType ? camelize(authorization.identityDocumentType.toLowerCase()) : '',
          identityDocumentId: authorization.identityDocumentId,
          coverageType: getCoverageTypeName(authorization.coverageType),
          status: getStatusAuthorizationName(authorization.status),
          detailFormSlug: authorization.detailFormSlug,
        }
      })
    }
    return []
  },
  filtersConfiguration: state => state.filtersConfiguration,
  authorizationDetail: state => {
    const authDetail = state.authorizationDetail

    if(!authDetail) return null
    if(!authDetail.comments) return state.authorizationDetail

    const comments = authDetail.comments.map(comment => ({
      ...comment,
      createdAtRaw: comment.createdAt,
      createdAt: {
        date: moment(comment.createdAt).format('DD/MM/YYYY'),
        time: moment(comment.createdAt).format('HH:mm a')
      },
      metadataComment: comment.metadataComment && camelizeKeys(JSON.parse(comment.metadataComment))
    }))

    return {
      ...state.authorizationDetail,
      comments
    }
  },
  authorizationLoading: (state) => state.authorizationLoading,
  authorizationForms: (state) => state.authorizationForms,
  authorizationFormsAndSteps: (state) => state.authorizationFormsAndSteps,
  currentForm: (state) => state.currentForm,
  currentStep: (state) => state.currentStep,
  formSteps: (state) => {
      if (state.currentForm) {
          return state.authorizationFormsAndSteps[state.currentForm].length
      }
      return 2
  },
  getError: (state) => state.error,
  inputs: (state) => state.inputs,
  stepError: (state) => state.stepError,
  accountsSearchValue: state => state.accountsSearchValue,
  createAuthorizationAction: state => state.createAuthorizationAction,
  accountPage: state => {
    const { page } = state
    return { ...page, number: page.number + 1 }
  },
  supportFileCatalog: state => state.supportFileCatalog.map(fileConfig => ({
    text: fileConfig.name,
    value: fileConfig.fileCode
  })),
  getSponsorStaticDocuments: (state) => state.authorizationSponsorStaticDocuments,
  getAuthorizationPreInvoice: (state) => state.authorizationPreInvoice,
  uploadFilesConfigurations: (state) => {
    const detailForm = state.authorizationDetailForm
    const fields = detailForm && detailForm.fields

    if(!fields) return []

    return fields
      .filter(field => field.type === 'FILE_UPLOAD')
      .filter(field => field.slug != 'pre_invoice')
      .filter(field => field.slug != 'invoice')
      .map(field => ({
        ...field,
        text: field.label,
        value: field.slug,
      }))
  },
  getPreInvoiceField: (state) => {
    return state.authorizationDetailForm?.fields?.find(field => field.slug == 'pre_invoice')
  },
  getAuthorizationInvoice: (state) => state.authorizationInvoice,
  getInvoiceField: (state) => {
    return state.authorizationDetailForm?.fields?.find(field => field.slug == 'invoice')
  }
}
